module.exports = __webpack_public_path__ + "img/bell-plus.40a3af60.svg";